import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MeetingForAction } from '../../interface';

@Component({
  templateUrl: './cancel-confirmation-dialog.component.html',
  styleUrls: ['./cancel-confirmation-dialog.component.scss'],
  standalone: false,
})
export class MeetingCancellationDialogComponent {
  cancellationForm: UntypedFormGroup;
  constructor(
    public dialogRef: MatDialogRef<MeetingCancellationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public meeting: MeetingForAction,
  ) {
    this.cancellationForm = new UntypedFormGroup({
      cancellationReason: new UntypedFormControl(),
    });
  }

  cancelMeeting(): void {
    const reason = this.cancellationForm.value.cancellationReason;
    this.dialogRef.close({ meetingId: this.meeting.meetingId, cancellationReason: reason });
  }

  close(): void {
    this.dialogRef.close();
  }
}
